module.exports = __webpack_public_path__ + "img/patent4.107ef818.jpg";